import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faDownload } from '@fortawesome/free-solid-svg-icons';

import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import { BASE_URL, API } from 'CONST';
import { get } from 'helpers/requests';
import { headerOperationTwoValues } from 'helpers/tables';
import { fileDownload } from 'helpers/helpers';
import Seccion from './ReporteConsolidado/seccion';

// Historial de rating desde BurosHub (solo lectura; se edita en BurosHub)
const ModalHistorialRating = ({ isOpen, toggle, rut }) => {

  const [historialRatings, setHistorialRatings] = useState([]);

  const fetchEvaluacion = () => {
    if (!rut) return;
    get(`${BASE_URL}${API.ratingBuroshub}/?rut=${encodeURIComponent(rut)}`)
      .then(response => {
        setHistorialRatings(response || []);
      })
      .catch(error => {
        console.error('Error al obtener los ratings:', error);
      });
  };

  useEffect(() => {
    if (isOpen) {
      fetchEvaluacion();
    }
  }, [isOpen]);

  const handleToggleDetails = (index) => {
    setHistorialRatings(prevRatings => {
      const newRatings = [...prevRatings];
      newRatings[index].expanded = !newRatings[index].expanded;
      return newRatings;
    });
  };


  return (
    <Modal isOpen={isOpen} style={{ maxWidth: "1000px", width: "70%" }} toggle={toggle} type="modal-warning warning-container">
      <ModalHeader toggle={toggle} style={{ paddingBottom: "20px", paddingTop: "40px" }}>
        Historial de Ratings
      </ModalHeader>
      <ModalBody style={{ paddingTop: "0px" }}>
        {(() => {
          if (historialRatings.length === 0) {
            return <p>No se encontraron datos.</p>;
          }

          return (
            <ul className="list-group">
              {historialRatings.map((item, index) => {
                const isExpanded = item.expanded;

                return (
                  <div key={index}>
                    <Button
                      className="list-group-item d-flex justify-content-between align-items-center"
                      style={{
                        cursor: 'pointer',
                        backgroundColor: '#f8f9fa',
                        color: '#343a40',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.25rem',
                        marginBottom: '0.5rem',
                        width: "100%",
                      }}
                      onClick={() => handleToggleDetails(index)}
                    >
                      {/* Ícono de expandir/colapsar */}
                      <FontAwesomeIcon
                        icon={isExpanded ? faMinus : faPlus}
                        className="svg-inline--fa fa-w-14 table-link"
                        style={{ marginRight: '10px' }}
                      />
                      <div className="d-flex justify-content-between w-100">
                        <div className="w-50 d-flex">
                          {headerOperationTwoValues(
                            'Rating',
                            item.intervalo_nota ? `${item.valor} (${item.intervalo_nota})` : item.valor,
                            'left',
                          )}
                        </div>
                        <div className="w-50 d-flex justify-content-end">
                          {headerOperationTwoValues('Fecha de Evaluación', new Date(item.fecha_evaluacion).toLocaleDateString('es-CL', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          }), 'right')}
                        </div>
                      </div>
                    </Button>

                    {isExpanded && (
                      <div className="details" style={{ paddingLeft: '15px', paddingTop: '10px' }}>
                        <Seccion
                          sectionData={[{
                            title: 'Detalles del Rating',
                            type: 'v_headers',
                            headers: {
                              comentarios: { name: 'Comentarios' },
                              modificado_por: { name: 'Modificado por' },
                            },
                            data: {
                              comentarios: item.comentarios || 'No hay comentarios',
                              modificado_por: item.modificado_por || 'No disponible',
                            },
                          }]}
                        />
                        <div className="d-flex align-items-center" style={{ paddingBottom: '10px' }}>
                          <span style={{ marginRight: '10px' }}>Documento de respaldo:</span>
                          {item.documento ? (
                            <Button
                              color="link"
                              size="sm"
                              className="p-0"
                              onClick={() => fileDownload(`${BASE_URL}${API.ratingBuroshub}/`, `${item.id}/documento/`)}
                            >
                              {item.documento.name}
                              <FontAwesomeIcon icon={faDownload} style={{ marginLeft: '6px' }} />
                            </Button>
                          ) : (
                            <span className="text-muted">Sin documento</span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </ul>
          );
        })()}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cerrar</Button>
      </ModalFooter>
    </Modal>
  );
};

ModalHistorialRating.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  rut: PropTypes.string,
};

ModalHistorialRating.defaultProps = {
  rut: null,
};

export default ModalHistorialRating;